import { Basic } from "../../basic.js";
import styles from './style.css'

const closeIcon = `
<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="23" height="23" viewBox="0 0 64 64">
<path d="M51.092 15.737L48.263 12.908 32 29.172 15.737 12.908 12.908 15.737 29.172 32 12.908 48.263 15.737 51.092 32 34.828 48.263 51.092 51.092 48.263 34.828 32z"></path>
</svg>
`
const template = `
    <style id="ui-modal-css">
       ${styles}
    </style>
    <div id="pens-window" class="pens-window">
        <div class="modal-header">
            <div id="modal-label" class="modal-label"></div>
            <div class="modal-close" id="modal-close">${closeIcon}</div>
        </div>
        <div class="modal-body">
            <slot />
        </div>
    </div>
`;

/**
 * @class UiModal
 * @classdesc Компонент UiModal
 * */

export class UiModal extends Basic {

    constructor() {
        super()
        this.state = {
            label: '',
            active: false
        }
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = template
        this.css = shadowRoot.querySelector('#ui-popup-css')
        this.modalRoot = shadowRoot.querySelector('#pens-window')
        this.modalCloseBtn = shadowRoot.querySelector('#modal-close')
        this.modalLabel = shadowRoot.querySelector('#modal-label')
        this.modalHeader = shadowRoot.querySelector('.modal-header')
        this.modalCloseBtn.addEventListener('click', this.close.bind(this))
        this.isFirstOpen = true
        this.style.overflow = 'visible'
        this.style.borderWidth = 0;
        this.style.position = "relative";
        this.style.height = "100%"
        this.style.width = "100%"
        this.modalRoot.style.display = 'none'
    }

    connectedCallback() {
        window.addEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
        if (this.active) {
            this.uiModal.initialPosition = this.calculateInitialPosition?.() || [0, 0];
        } else {
            this.isFirstOpen = true;
        }
    }

    toggle() {
        this.active = !this.active
        if(this.isFirstOpen && this.active){
            this.uiModal.initialPosition = this.calculateInitialPosition?.() || [0, 0];
            this.isFirstOpen = false;
        }
    }

    close() {
        this.active = false
    }

    open(){
        this.active = true
        if(this.isFirstOpen){
            this.uiModal.initialPosition = this.calculateInitialPosition?.() || [0, 0];
            this.isFirstOpen = false;
        }
    }

    delete(){
        const element = this?.uiModal?.element
        if(!element) return
        const parentElement = element.parentElement;
        if (parentElement) {
            parentElement.removeChild(element);
        }
    }

    disconnectedCallback() {
        this.modalCloseBtn.removeEventListener('click', this.close.bind(this));
        window.removeEventListener('resize', this.handleResize);
        this.css = null;
        this.modalRoot = null;
        this.modalCloseBtn = null;
        this.modalLabel = null;
        this.uiModal = null;
        
        this.state = null;
        this.isFirstOpen = null;

        while (this.firstChild) {
            this.removeChild(this.firstChild);
        }
        
        this.rootDestroy()
        super.disconnectedCallback();
    }

    get active() {
        return this.state.active
    }
    set active(value) {
        this.state.active = value
        this.changeActive?.(value);
        if (this.state.active){
            this.modalRoot.style.display = 'flex'
            this.root.style.display = 'block'
        } else {
            this.modalRoot.style.display = 'none'
            this.root.style.display = 'none'
        }
    }


    get label() {
        return this.state.label;
    }
    set label(v) {
        this.state.label = v
        this.modalLabel.innerHTML = v
    }
}